const model = {
  id: '',
  b_created_date: '',
  b_dmst_conclusion: '',
  b_tier_two_candidate: '',
  b_first_name: '',
  b_last_name: '',
  b_confirmed: '',
  b_confirmation_source: '',
  b_confirmation_LE: false,
  b_confirmation_LE_date: '',
  b_confirmation_LE_comment: '',
  b_confirmation_Victim: false,
  b_confirmation_Victim_date: '',
  b_confirmation_Victim_comment: '',
  b_confirmation_CPS: false,
  b_confirmation_CPS_date: '',
  b_confirmation_CPS_comment: '',
  b_confirmation_Med: false,
  b_confirmation_Med_date: '',
  b_confirmation_Med_comment: '',
  b_confirmation_Expert: false,
  b_confirmation_Expert_date: '',
  b_confirmation_Expert_comment: '',
  b_confirmation_Other: false,
  b_confirmation_Other_date: '',
  b_confirmation_Other_comment: '',
  b_type_of_trafficking_sex: false,
  b_type_of_trafficking_labor: false,
  b_type_of_trafficking_forced_marriage: false,
  b_birthdate: '',
  b_approximate_age: '',
  b_race: '',
  b_race_otherText: '',
  b_ethnicity: '',
  b_ethnicity_otherText: '',
  b_gender: '',
  b_gender_otherText: '',
  b_gender_identity: '',
  b_gender_identity_otherText: '',
  b_orientation: '',
  b_orientation_otherText: '',
  b_immigration_category: '',
  p_pid: '',
  p_presenting_offense: '',
  p_presenting_offense_otherText: '',
  p_street_name: '',
  p_last_home_location: '',
  p_grade_level: '',
  p_education_type: '',
  b_disability: '',
  b_disability_otherText: '',
  p_country_of_origin: '',
  p_imm_status: '',
  p_imm_doc: '',
  p_imm_exp: '',
  p_imm_text: '',
  p_poverty_line: '',
  p_forcedlabor: '',
  p_guardian: '',
  p_guardian_otherText: '',
  p_perpetrator_known: '',
  p_perpetrator_name: '',
  p_cps_called: '',
  p_cps_call_date: 0,
  p_cps_id_number: '',
  p_cps_reference_number: '',
  p_le_called: '',
  p_le_call_date: 0,
  p_le_agency: '',
  p_le_agency_otherText: '',
  p_cac_interview: '',
  p_gang_affiliation: '',
  p_tattoos: '',
  p_tattoo_photo: '',
  p_tattoo_description: '',
  p_runaway: '',
  p_substance_use: '',
  p_substance_use_description: '',
  p_internet_involved: '',
  p_outcry: '',
  i_possible: '',
  case_notes: '',
  p_gang_description: '',
  p_gang_county: '',
  p_social_media: '',
  d_social_media: '',

  // means of sex trafficking
  i_s_commercial_sex_exploitation_of_child: false,
  i_s_forced_commercial_sex_exploitation: false,
  i_s_familial_facilitated: false,
  i_s_gang_facilitated: false,
  i_s_minor_engaged_in_survival_sex: false,

  // means of labor trafficking
  i_l_domestic_servitude: false,
  i_l_familial_facilitated: false,
  i_l_gang_facilitated: false,
  i_l_industry_related: false,

  // trafficked industry related option
  i_l_trafficked_industry: '',
  i_l_trafficked_industry_otherText: ''
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/person.js